import {createSvgIcon} from '@yandex-delivery/blocks/icons/utils'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

const className = css`
  inline-size: ${spacing(1.5)};
  block-size: ${spacing(0.875)};
  margin-inline-start: ${spacing(0.625)};
`

export default createSvgIcon(
  <svg fill="none" height="7" viewBox="0 0 12 7" width="12" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 0.75L6 5.75L11 0.75" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,
  'ChevronIcon',
  {viewBox: '0 0 12 7', rtlTransform: true, className},
)
